import { ApiConfig, AppConfig as ApplicationConfig, OktaConfig } from './app';

export const environmentCaptcha = {
  // production: false,
  recaptcha: {
    siteKey: '6LeuPegoAAAAAE31X0H9a3SWAEVKueI1kv1N8Qe1',
  },
  eventServiceURL: 'https://holdandrecall-event-service-dev.apps.cf.np.gc.cahcloud.net'
};

export class Environment {
  /*********************Properties*********************/

  get appConfig(): ApplicationConfig {
    return this.applicationConfiguration;
  }

  set appConfig(config: ApplicationConfig) {
    this.applicationConfiguration = config;
  }

  get apiConfig(): ApiConfig {
    return this.apiConfiguration;
  }

  set apiConfig(config: ApiConfig) {
    this.apiConfiguration = config;
  }

  get oktaConfig(): OktaConfig {
    return this.oktaConfiguration;
  }

  set oktaConfig(config: OktaConfig) {
    this.oktaConfiguration = config;
  }

  get sessionExpiryMessages(): any {
    return this.expiryMessage;
  }
  
  set sessionExpiryMessages(message: string) {
    this.expiryMessage = message;
  }

  private static instance: Environment;
  jwtApigeeUrl :string = "https://api.dev.cardinalhealth.com/"
  private applicationConfiguration: ApplicationConfig = {
    appDown: false,
    appLoaded: false,
    apiTimeOut: 20,
    appTimeOut: 20,
    internalLoginUrl: null
  };

  private expiryMessage: string = 'You have successfully logged out.'

  private apiConfiguration: ApiConfig = {
    apiUrl: '',
    holdUrl: '',
    loginUrl: '',
    jwtUrl: '',
    externalUrl: '',
    redirectUrl: '',
    clientId: '',
    reportUrl:'',
    extRedirectUrl:'',
    groupId: '',
    externalLogin: '',
    siteKey:'',
    textMaxLength:''
    }

  private oktaConfiguration: OktaConfig = {
    clientId: '',
    issuer: '',
    scope: '',
  };
  
  private constructor() {}

  static getInstance() {
    if (!Environment.instance) {
      Environment.instance = new Environment();
    }

    return Environment.instance;
  }
}
  